import { APIDirectory, HTTP } from '../../rest'
import { constant } from "./SubscriptionActionConstants";
import { SchoolInformationActions } from "../schoolInformation"
import paddleConfig from '../../security/paddleConfig.json'
const Paddle = window.Paddle;
export const addMoreSectionsToSubscriptionInProgress = () => {
    return {
        type: constant.ADD_MORE_SECTIONS_TO_SUBSCRIPTION_IN_PROGRESS
    }
}

export const addMoreSectionsToSubscriptionComplete = (data) => {
    return {
        type: constant.ADD_MORE_SECTIONS_TO_SUBSCRIPTION_COMPLETE,
        data: data
    }
}

export const addMoreTimetablesToSubscriptionInProgress = () => {
    return {
        type: constant.ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_IN_PROGRESS
    }
}

export const addMoreTimetablesToSubscriptionComplete = (data) => {
    return {
        type: constant.ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_COMPLETE,
        data: data
    }
}

export const cancelSubscriptionInProgress = () => {
    return {
        type: constant.CANCEL_SUBSCRIPTION_IN_PROGRESS
    }
}

export const cancelSubscriptionComplete = (data) => {
    return {
        type: constant.CANCEL_SUBSCRIPTION_COMPLETE,
        data: data
    }
}

export const addMoreSectionsToSubscription = (ownerId, subscribingPackage) => {
    return async dispatch => {
        try {
            dispatch(addMoreSectionsToSubscriptionInProgress());
            let url = APIDirectory.getAddMoreSectionsToSubscriptionsURL();
            let response = await HTTP.POST(url, subscribingPackage);
            dispatch(addMoreSectionsToSubscriptionComplete(response));
            dispatch(SchoolInformationActions.getSchoolsSummary(ownerId));
            return {status:true};
        }
        catch (error) {

            return {status:false};
        }

    }
}

export const addMoreTimetablesToSubscription = (ownerId, subscribingPackage) => {
    return async dispatch => {
        try {
            dispatch(addMoreTimetablesToSubscriptionInProgress());
            let url = APIDirectory.getAddMoreTimetablesToSubscriptionsURL();
            let response = await HTTP.POST(url, subscribingPackage);
            dispatch(addMoreTimetablesToSubscriptionComplete({}))
            dispatch(SchoolInformationActions.getSchoolsSummary(ownerId));
        }
        catch (error) {
            return [];
        }

    }
}

export const cancelSubscription = (ownerId, subscribedPackage) => {
    return async dispatch => {
        try {
            dispatch(cancelSubscriptionInProgress());
            let url = APIDirectory.getCancelSubscriptionURL()
            let response = await HTTP.POST(url, subscribedPackage);
            dispatch(cancelSubscriptionComplete({}))
            dispatch(SchoolInformationActions.getSchoolsSummary(ownerId));
        } catch (error) {
            console.log(error)
            dispatch(cancelSubscriptionComplete({}))
            return [];
        }
    }
}

export const getSubscriptionInProgress = () => {
    return {
        type: constant.GET_SUBSCRIPTION_IN_PROGRESS
    }
}

export const getSubscriptionCompleted = () => {
    return {
        type: constant.GET_SUBSCRIPTION_COMPLETED
    }
}
export const getSubscriptionFailed = () => {
    return {
      type: constant.GET_SUBSCRIPTION_FAILED
    }
  }
export const getSubscription = (school, numberOfSections,ownerId) => {
    return async dispatch => {
        try {
            dispatch(getSubscriptionInProgress());
            Paddle.Setup({ vendor: paddleConfig.paddleVendorId });
            await Paddle.Checkout.open({
                product: paddleConfig.paddleSubscriptionPlanID,
                email: school.email,
                quantity: numberOfSections,
                allowQuantity: false,
                passthrough: { schoolId: school._id },
                successCallback: async (data, err) => {
                    if (Boolean(data.checkout.completed)) {
                        dispatch(getSubscriptionCompleted());
                        dispatch(SchoolInformationActions.getSchoolsSummary(ownerId));
                        return data.checkout
                    } else {
                        dispatch(getSubscriptionFailed());
                        return data.checkout
                    }
                }
            });
        } catch (error) {
            dispatch(getSubscriptionFailed());
        }
    }
}

//aws cognito-idp admin-create-user --region ap-southeast-1 --user-pool-id ap-southeast-1_5uyFXKdWG --username vaughan.brok@andyes.net --message-action RESEND